import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { EnumType11cgb4df0n5r9 as EnumType } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Badge_Default_instance;
var Badge_Alternate_instance;
var Badge_UNKNOWN___instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.a6m_1 = new (EnumType())('Badge', listOf(['Default', 'Alternate']));
      }
      w6l(rawValue) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = get_entries();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.u1();
          while (_iterator__ex2g4s.v1()) {
            var element = _iterator__ex2g4s.w1();
            if (element.d6m_1 === rawValue) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$1;
        return tmp0_elvis_lhs == null ? Badge_UNKNOWN___getInstance() : tmp0_elvis_lhs;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  Badge_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function values() {
  return [Badge_Default_getInstance(), Badge_Alternate_getInstance(), Badge_UNKNOWN___getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Badge_entriesInitialized;
function Badge_initEntries() {
  if (Badge_entriesInitialized)
    return Unit_instance;
  Badge_entriesInitialized = true;
  Badge_Default_instance = new (Badge())('Default', 0, 'Default');
  Badge_Alternate_instance = new (Badge())('Alternate', 1, 'Alternate');
  Badge_UNKNOWN___instance = new (Badge())('UNKNOWN__', 2, 'UNKNOWN__');
  Companion_getInstance();
}
var $ENTRIES;
var BadgeClass;
function Badge() {
  if (BadgeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, rawValue) {
        super(name, ordinal);
        this.d6m_1 = rawValue;
      }
    }
    initMetadataForClass($, 'Badge');
    BadgeClass = $;
  }
  return BadgeClass;
}
function Badge_Default_getInstance() {
  Badge_initEntries();
  return Badge_Default_instance;
}
function Badge_Alternate_getInstance() {
  Badge_initEntries();
  return Badge_Alternate_instance;
}
function Badge_UNKNOWN___getInstance() {
  Badge_initEntries();
  return Badge_UNKNOWN___instance;
}
//region block: exports
export {
  Badge as Badge28jlxgdx0n9um,
  Badge_Alternate_getInstance as Badge_Alternate_getInstance3d5t8xaeazn33,
  Badge_Default_getInstance as Badge_Default_getInstance1xo16d4uigsos,
  Companion_getInstance as Companion_getInstance18pou2hmrulr2,
};
//endregion

//# sourceMappingURL=Badge.mjs.map
